/**
 * A class that handles constraints. By default a constraint object is not active, it has to be activated with the activated function.
 */
class Constraints {
  constructor() {
    this.constraints = [];
    this.active = false;
  }

  /**
   * Activates the constrains object.
   */
  activate() {
    this.active = true;
  }

  /**
   * Adds a constraint. Constrains are composed of an HTML Element ctx, an constraint function proof a clear function clear.
   * @param {HTMLElement} ctx Contex HTML Element. This Element is used to identify the constraints.
   * @param {Function} proof Callback function that will be called when the constraint is called. The ctx param is passed when called.
   * An in addtion an called parameter. This parameter
   * @param {Function} clear Callback function that will be called when the constraint is removed. The ctx param is passed when called.
   */
  add(ctx, proof, clear) {
    var index = this.constraints.findIndex((con) => con.ctx == ctx);
    // no duplicates allowed!
    if (index < 0)
      this.constraints.push({
        ctx: ctx,
        proof: proof,
        clear: clear,
        called: false,
      });
  }
  /**
   * Removes the constraint and calls its clear function.
   * @param {HTMLElement} ctx ThisHTMLElement is used to identify the constraint that shall be removed.
   */
  remove(ctx) {
    var index = this.constraints.findIndex((con) => con.ctx == ctx);

    if (index < 0) return;

    this.constraints[index].clear(this.constraints[index].ctx);
    this.constraints.splice(index, 1);
  }
  /**
   * Calls the proof function of all constraints.
   */
  callAll() {
    if (this.active) {
      this.constraints.forEach((con) => {
        con.called = con.proof(con.ctx, con.called);
      });
    }
  }
}
